import gql from 'graphql-tag';

export const SendBroadcastMutation = gql`
  mutation SendBroadcastMutation($objects: [chat_insert_input!]!) {
    insert_chat(objects: $objects) {
      affected_rows
    }
  }
`;

export const GetBroadcastsQuery = gql`
  query GetBroadcastsQuery($userId: uuid!) {
    chat(where: {userId: {_eq: $userId}, isBroadcastMessage: {_eq: true}}, limit: 15, order_by: {createdAt: desc}) {
      id
      broadcastButtonLink
      broadcastImage
      broadcastMessage
      broadcastTitle
      isBroadcastLive
      isBroadcastMessage
      createdAt
    }
  }
`;

export const GetBroadcastQuery = gql`
  query GetBroadcastQuery($userId: uuid!, $id: uuid!) {
    chat(where: {userId: {_eq: $userId}, id: {_eq: $id}, isBroadcastMessage: {_eq: true}}) {
      id
      broadcastButtonLink
      broadcastImage
      broadcastMessage
      broadcastTitle
      isBroadcastLive
      isBroadcastMessage
      createdAt
    }
  }
`;

export const UpdateBroadcastMutation = gql`
  mutation UpdateBroadcastMutation($id: uuid!, $set: chat_set_input!) {
    update_chat_by_pk(pk_columns: {id: $id}, _set: $set) {
      id
      broadcastButtonLink
      broadcastImage
      broadcastMessage
      broadcastTitle
      isBroadcastLive     
      isBroadcastMessage
      createdAt
    }
  }
`;  

export const DeleteBroadcastMutation = gql`
  mutation DeleteBroadcastMutation($id: uuid!) {
    delete_chat_by_pk(id: $id) {
      id
    }
  }
`;

export const DeleteBroadcastMetadataMutation = gql`
  mutation DeleteBroadcastMetadataMutation($broadcasterId: uuid!) {
    delete_chatMetadata(where: {broadcasterId: {_eq: $broadcasterId}}) {
      affected_rows
    }
  }
`;
